/* global axios */
import ApiClient from './ApiClient';

class FormsAPI extends ApiClient {
  constructor() {
    super('forms', { accountScoped: true });
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  unpublish(id) {
    return axios.post(`${this.url}/${id}/unpublish`);
  }
}

export default new FormsAPI();
